import * as React from 'react';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Sheet from '@amzn/meridian/sheet';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import closeTokens from '@amzn/meridian-tokens/base/icon/close-small';
import cogTokens from '@amzn/meridian-tokens/base/icon/cog';
import Heading from '@amzn/meridian/heading';
import { useState } from 'react';
import Divider from '@amzn/meridian/divider';
import Select, { SelectOption } from '@amzn/meridian/select';
import { Locales, Regions } from '../../Util/Locales';
import escapeRegExp from 'lodash/escapeRegExp';
import Text from '@amzn/meridian/text';
import { getDomainUrl } from '../../config/EnvConfig';
import { getLocaleStringFormatted } from '../../translations';
import { FormattedMessage, useIntl } from 'react-intl';
import { getEnvConfigByKey } from '../../config/EnvConfig';

export const SettingPanel = () => {
  const [open, setOpen] = React.useState(false);

  const onClickOpen = React.useCallback(() => setOpen(true), []);
  const onClose = React.useCallback(() => setOpen(false), []);

  const [language, setLanguage] = useState(
    getLocaleStringFormatted() || 'en-US'
  );
  const [region, setRegion] = useState(getEnvConfigByKey('regionName') || 'na');
  const [searchQuery, setSearchQuery] = useState();
  const intl = useIntl();

  const searchRegExp = new RegExp(escapeRegExp(searchQuery), 'i');
  const matchedOptionsLanguage = Locales.filter(
    locale => !searchQuery || searchRegExp.test(locale[1])
  );
  const matchedOptionsRegion = Regions.filter(
    region => !searchQuery || searchRegExp.test(region[1])
  );

  const handleRedirectButtonClick = (region: any, language: any) => {
    let url = getDomainUrl(region);
    window.location.href = `${url}?l=${language}`;
  };

  return (
    <>
      <Row alignmentHorizontal='end'>
        <Button type='icon' onClick={onClickOpen}>
          <Icon tokens={cogTokens}>Settings</Icon>
        </Button>
      </Row>
      <Sheet
        type='overlay'
        side='end'
        open={open}
        onClose={onClose}
        data-testid='settings-panel'
      >
        <Column>
          <Row alignmentHorizontal='end'>
            <Button onClick={onClose} type='icon'>
              <Icon tokens={closeTokens}>Close sheet</Icon>
            </Button>
          </Row>
        </Column>
        <Heading level={3}>
          <FormattedMessage
            id='cs_perfportal_setting_panel'
            defaultMessage='Settings'
            description='Settings Title'
          />
        </Heading>
        <Column spacing='300'>
          <Text color='secondary'>
            <FormattedMessage
              id='cs_perfportal_setting_panel_language'
              defaultMessage='Language'
              description='Language Title'
            />
          </Text>
          <Select
            value={language}
            onChange={setLanguage}
            searchQuery={searchQuery}
            onSearch={setSearchQuery}
            width={240}
            placeholder={intl.formatMessage({
              id: 'cs_perfportal_setting_panel_select_language',
              defaultMessage: 'Select Language',
            })}
          >
            {matchedOptionsLanguage.map(option => (
              <SelectOption
                label={option[1]}
                value={option[0]}
                key={option[1]}
              />
            ))}
            {!matchedOptionsLanguage.length ? (
              <Column
                alignmentVertical='center'
                spacing='200'
                spacingInset='300'
              >
                <Text alignment='center'>No results</Text>
              </Column>
            ) : null}
          </Select>
          <Text color='secondary'>
            <FormattedMessage
              id='cs_perfportal_setting_panel_region'
              defaultMessage='Region'
              description='Region Title'
            />
          </Text>
          <Select
            value={region}
            onChange={setRegion}
            width={240}
            searchQuery={searchQuery}
            onSearch={setSearchQuery}
            placeholder={intl.formatMessage({
              id: 'cs_perfportal_setting_panel_select_region',
              defaultMessage: 'Select Region',
            })}
          >
            {matchedOptionsRegion.map(option => (
              <SelectOption
                label={option[1]}
                value={option[0]}
                key={option[1]}
              />
            ))}
            {!matchedOptionsRegion.length ? (
              <Column
                alignmentVertical='center'
                spacing='200'
                spacingInset='300'
              >
                <Text alignment='center'>No results</Text>
              </Column>
            ) : null}
          </Select>
          <Divider />
          <Row
            width='100%'
            widths='fill'
            alignmentHorizontal='center'
            spacing='none'
          >
            <Button
              size='medium'
              onClick={e => handleRedirectButtonClick(region, language)}
            >
              <FormattedMessage
                id='cs_perfportal_setting_panel_update_settings'
                defaultMessage='Update Settings'
                description='Update Settings Button'
              />
            </Button>
          </Row>
        </Column>
      </Sheet>
    </>
  );
};
